import React from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'
import FlexContentHandler from 'components/shared/FlexContentHandler'

interface PageProps {
  data: {
    page: {
      title?: string
      path?: string
      seo: any
      flexContent: any
      vacaturedetail: any
      vacatureTypes: any
    }
  }
  location?: any
}

export const VacatureContext = React.createContext({})

const PageTemplate: React.FC<PageProps> = ({
  data: {
    page: { title, vacaturedetail, vacatureTypes, flexContent, seo },
  },
  location = {},
}) => (
  <Layout>
    <SEO seo={seo} />
    <VacatureContext.Provider
      value={{ details: vacaturedetail, name: title, vacatureTypes }}
    >
      <FlexContentHandler
        prefix="Vacature_Flexcontent"
        fields={flexContent}
        location={location}
      />
    </VacatureContext.Provider>
  </Layout>
)

export const pageQuery = graphql`
  query vacatureById($id: String!) {
    page: wpVacature(id: { eq: $id }) {
      ...generalVacatureFragment
    }
  }
`

export default PageTemplate
